import React from 'react';
import classNames from 'classnames';
import {
	AssignmentType,
	AssignmentStatus
} from 'LearningManager/constants/CoursesAssignment.types';
import styles from './AssignmentBadge.module.scss';
import { useTranslation } from 'react-i18next';

export type AssignmentBadgeType =
	| AssignmentType
	| AssignmentStatus
	| 'Required'
	| 'Optional';

interface AssignmentBadgeProps {
	type: string;
	className?: string;
}

const TYPE_CLASS: Record<string, string> = {
	'One-Time': styles['badge--oneTime'],
	Ongoing: styles['badge--ongoing'],
	Scheduled: styles['badge--scheduled'],
	Active: styles['badge--active'],
	Completed: styles['badge--completed'],
	Required: styles['badge--scheduled'],
	Optional: styles['badge--scheduled'],
	'In Progress': styles['badge--ongoing'],
	Complete: styles['badge--completed']
};

export const TYPE_LABEL : Record<string, string> = {
	'One-Time': 'learning.courseCard.typeLabels.oneTime',
	Ongoing: 'learning.courseCard.typeLabels.ongoing',
	Scheduled: 'learning.courseCard.typeLabels.scheduled',
	Active: 'learning.courseCard.typeLabels.active',
	Completed: 'learning.courseCard.typeLabels.completed',
	Required: 'learning.courseCard.typeLabels.required',
	Optional: 'learning.courseCard.typeLabels.optional',
	'In Progress': 'learning.courseCard.typeLabels.inProgress',
	Complete: 'learning.courseCard.typeLabels.complete',
	'Not Started': 'learning.courseDetails.status.notStarted',
	'Not started': 'learning.courseDetails.status.notStarted'
}

const AssignmentBadge: React.FC<AssignmentBadgeProps> = ({
	type,
	className
}) => {
	const { t } = useTranslation();
	const badgeType = TYPE_LABEL[type] ? t(TYPE_LABEL[type]) : type;
	return <span className={classNames(styles.badge, TYPE_CLASS[type], className)}>{badgeType}</span>
}

export default AssignmentBadge;
